"use client";
import { useEffect, useState } from "react";
function getCountdownParts(endsAt) {
    var end = new Date(endsAt).getTime();
    var diff = end - Date.now();
    if (Number.isNaN(end) || diff <= 0) {
        return { expired: true, days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    return {
        expired: false,
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60),
    };
}
export function useCountdown(endsAt) {
    var _a = useState(function () { return getCountdownParts(endsAt); }), parts = _a[0], setParts = _a[1];
    useEffect(function () {
        setParts(getCountdownParts(endsAt));
        var interval = setInterval(function () {
            setParts(function (previous) {
                if (previous.expired) {
                    clearInterval(interval);
                    return previous;
                }
                return getCountdownParts(endsAt);
            });
        }, 1000);
        return function () { return clearInterval(interval); };
    }, [endsAt]);
    return parts;
}
var pad = function (value) { return String(value).padStart(2, "0"); };
export function formatCountdown(parts) {
    var clock = "".concat(pad(parts.hours), ":").concat(pad(parts.minutes), ":").concat(pad(parts.seconds));
    return parts.days > 0 ? "".concat(parts.days, "d ").concat(clock) : clock;
}
//# sourceMappingURL=use-countdown.js.map